import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, MessageSquare } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import styles from "./NotFoundPage.module.scss";

/**
 * Catch-all for any path the router doesn't know. Styled as a departures
 * board row, so a broken link still feels like part of the product.
 */
export const NotFoundPage = () => {
    const location = useLocation();

    useEffect(() => {
        const previous = document.title;
        document.title = "Page not found · Adiona";
        return () => {
            document.title = previous;
        };
    }, []);

    return (
        <div className={styles.page}>
            <Header />
            <main className={styles.content}>
                <div className={styles.board} role="img" aria-label="Departures board: flight AD 404, destination unknown, cancelled">
                    <span className={styles.boardLabel}>Flight</span>
                    <span className={styles.boardLabel}>Destination</span>
                    <span className={styles.boardLabel}>Status</span>
                    <span className={styles.boardValue}>AD 404</span>
                    <span className={styles.boardValue}>Unknown</span>
                    <span className={`${styles.boardValue} ${styles.boardStatus}`}>Cancelled</span>
                </div>

                <h1 className={styles.title}>This page took a wrong turn</h1>
                <p className={styles.text}>
                    There's nothing at <code className={styles.path}>{location.pathname}</code>. The link may be
                    old or mistyped. Your trips are safe, and Adiona can take you somewhere better.
                </p>

                <div className={styles.actions}>
                    <Link to="/" className={styles.primary}>
                        Back to home <ArrowRight size={16} aria-hidden="true" />
                    </Link>
                    <Link to="/chat" className={styles.secondary}>
                        <MessageSquare size={16} aria-hidden="true" /> Plan a trip in chat
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
};
